<div class="glass context-holder">
    <ul class="list-group list-group-flush my-3">
        <li *ngIf="userIsOwner" class="list-group-item pointer list-group-item-action d-flex justify-content-between align-items-center"
            (click)="delete()">
            <div>Delete</div>
            <fa-icon [icon]="iconsService.faIconsSolid.faTrash"></fa-icon>
        </li>
        <li *ngIf="!userIsOwner" class="list-group-item list-group-item-action pointer d-flex justify-content-between align-items-center"
            (click)="location.href='mailto:support@binst.net'">
            <div>Report</div>
            <fa-icon [icon]="iconsService.faIconsSolid.faExclamationCircle"></fa-icon>
        </li>
        <!--        <li class="list-group-item list-group-item-action pointer">A second item</li>-->
        <!--        <li class="list-group-item list-group-item-action pointer">A third item</li>-->
        <!--        <li class="list-group-item list-group-item-action pointer">A fourth item</li>-->
        <!--        <li class="list-group-item list-group-item-action pointer">And a fifth one</li>-->
    </ul>
</div>
